import { Component, Input } from "@angular/core";

@Component({
  selector: "app-bar-gauge",
  templateUrl: "./bar-gauge.component.html",
  styleUrls: ["./bar-gauge.component.css"]
})
export class BarGaugeComponent {
  @Input() palette = "Office";
  @Input() startValue = "0";
  @Input() endValue: string;
  @Input() values: any[];
  @Input() showLabel = false;
  @Input() showTooltip = true;

  constructor() {}
}
